module.exports = __webpack_public_path__ + "img/BackgroundVjorngard1.8dd34503.jpg";